<template>
  <div >
    <h4>User Access Authorizations for: {{username}}</h4>
    <div class="dx-field">
      <div class="dx-field-label">User Account Actions</div>
      <div class="dx-field-value">
        <DxButton
          text="Delete User"
          type="danger"
          :disabled="!isMyUserAdmin"
          @click="deleteUser"
          />
        <DxButton
          text="Set Password"
          :disabled="!isMyUserAdmin"
          @click="showSetUserPass"
          />
      </div>
    </div>
    <div class="dx-field">
      <div class="dx-field-label">Web Application Acccess</div>
      <div class="dx-field-value">
        <DxRadioGroup
          style="float: right;"
          :items="webAuthTypes"
          value-expr="value"
          display-expr="name"
          v-model:value="userPrivileges.web"
          layout="horizontal"
          @value-changed="e => {updateUserAuth(DEF_AUTHCODES.web, e.value, e.previousValue)}"
        />
      </div>
    </div>
    <div class="dx-field">
      <div class="dx-field-label">Administration Privileges</div>
      <div class="dx-field-value">
        <DxRadioGroup
          style="float: right;"
          :items="admonAuthTypes"
          value-expr="value"
          display-expr="name"
          v-model:value="userPrivileges.admon"
          layout="horizontal"
          @value-changed="e => {updateUserAuth(DEF_AUTHCODES.admon, e.value, e.previousValue)}"
        />
      </div>
    </div>
    <div class="dx-field">
      <div class="dx-field-label">IoT - MQTT Privileges</div>
      <div class="dx-field-value">
        <DxRadioGroup
          style="float: right;"
          :items="iotAuthTypes"
          value-expr="value"
          display-expr="name"
          v-model:value="userPrivileges.iot"
          layout="horizontal"
          @value-changed="e => {updateUserAuth(DEF_AUTHCODES.iot, e.value, e.previousValue)}"
        />
      </div>
    </div>
    <div class="dx-field">
      <div class="dx-field-label">Edit Dashboard Access Permissions</div>
      <div class="dx-field-value">
      <DxSwitch v-model:value="isDashboardPermUpdatable"/>
      </div>
    </div>
    <h4>Access to Dashboards Folders for: {{username}}</h4>
    <DxList
        :data-source="teamsDataSource"
        ref="userTeamsAccessList"
        display-expr="name"
        :disabled="!isDashboardPermUpdatable"
        :show-selection-controls="true"
        selection-mode="multiple"
        v-model:selected-item-keys="selectedItemKeys"
        @selection-changed="updateUserTeams"
      />

    <DxPopup
      content-template="change-passwd-form"
      :title="'Change Password For: ' +username"
      max-width="350px"
      max-height="450px"
      :show-close-button="true"
      v-model:visible="isSetPasswordPopupVisible"
      :hide-on-outside-click="true">
      <template #change-passwd-form>
        <DxScrollView width="100%" height="100%" >
          <SetPasswordForm :username="username" @request-finish="hideSetUserPass"/>
        </DxScrollView>
      </template>            
    </DxPopup>
  </div>
</template>
<script>
import { ref, reactive } from 'vue';
import { useStore } from 'vuex';
import RawDataService from '../services/RawDataServiceTemplate';
import DataService from '../services/DataServiceTemplate';
import auth from "../services/auth";
// import { useRouter } from 'vue-router';
import SetPasswordForm from '../components/settings-change-password.vue';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import DxRadioGroup from 'devextreme-vue/radio-group';
import { DxSwitch } from 'devextreme-vue/switch';
import DxButton from 'devextreme-vue/button';
import DxList from 'devextreme-vue/list';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';


export default {
  components:{
    DxRadioGroup,
    DxList,
    DxButton,
    SetPasswordForm,
    DxPopup,
    DxScrollView,
    DxSwitch,
  },
  props: {
    templateData: {
      type: Object,
      default: ()=>{}
    }
  },
  emits: ['user-update'],
  setup(props, { emit }) {
    const store = useStore();
    const DEF_AUTHCODES = { web:1, admon:100, iot:120 };
    const DEF_AUTHCODENAMES = { "1":"web", "100":"admon", "120":"iot" };
    const isMyUserAdmin = store.getters.hasAdminAccess(DEF_AUTHCODES.admon);//readonly - sourceuser
    const username = ref(props.templateData.data.username); 
    const webAuthTypes = ref([
      { name: 'Disabled', value: 0}, 
      { name: 'Enabled', value: 1}]);
    const admonAuthTypes = ref([
      { name: 'User', value: 1}, 
      { name: 'Administrator', value: 7}]);
    const iotAuthTypes = ref([
      { name: 'None', value: 0}, 
      { name: 'Reader', value: 1}, 
      { name: 'Manager', value: 7}]);
    const userTeamsAccessList = ref({});
    //TODO: request user permission for authcode
    const userPrivileges = reactive(
      { web:null, admon:null, iot:null });
    const selectedItemKeys = ref([]);
    const isUserAuthReady = ref(false); 
    const isUserTeamsReady = ref(false); 
    const isDashboardPermUpdatable = ref(false);
    const orgTeamsDataService = new DataService('sites/local/teams', 'id');
    const userTeamsDataService = new RawDataService(`users/${username.value}/teams`);
    const userOrgAuthDataService = new RawDataService(`users/${username.value}/authCodes`);
    const stErrorCb = err => { notify(err.message, "error", 3000); }

    userTeamsDataService.getAll().then(response => {
      for (let team of response){
        selectedItemKeys.value.push(team.id)
      }
      userTeamsAccessList.value.instance.repaint()
      isUserTeamsReady.value = true;
    })

    userOrgAuthDataService.getByKey(DEF_AUTHCODES.web)
    .then(response => { userPrivileges.web=response.value; }).catch(stErrorCb);
    userOrgAuthDataService.getByKey(DEF_AUTHCODES.admon)
    .then(response => { userPrivileges.admon=response.value; }).catch(stErrorCb);
    userOrgAuthDataService.getByKey(DEF_AUTHCODES.iot)
    .then(response => { userPrivileges.iot=response.value; }).catch(stErrorCb);
  
    const updateUserAuth = (authCode, newValue, oldValue) => {
      if (!isUserAuthReady.value || oldValue==null) { isUserAuthReady.value=true; return ; }
      userOrgAuthDataService.sendPatch(authCode, { username: username.value, value: newValue })
      .then( res => { notify(res.message||"Auth changed", "success", 3000); })
      .catch( err=> { 
        isUserAuthReady.value=false;
        userPrivileges[DEF_AUTHCODENAMES[authCode]]=oldValue;
        notify(err.message, "error", 3000); 
      })
    }
    const updateUserTeams = (e) => {
      if (!isUserTeamsReady.value){return ;}
      if (!!e.addedItems && e.addedItems.length>0) {
        userTeamsDataService.create({ grafanaTeamId: e.addedItems[0].id })
        .then( res => { notify(res.message, "success", 3000); })
        .catch( err=> { notify(err.message, "error", 3000); })
      }
      if (!!e.removedItems && e.removedItems.length>0) {
        userTeamsDataService.remove(e.removedItems[0].id)
        .then( res => { notify(res.message, "success", 3000); })
        .catch( err=> { notify(err.message, "error", 3000); })
      }
    }

    const deleteUser = async () => {
      try{
        const dialogResult = await confirm("Are you sure you want to delete the user?")
        if(dialogResult){
          const result = await auth.deleteLocalUser(username.value);
          if (result.isOk) {
            notify('Account deleted Successfully!', 'success', 3000);
            emit('user-update', { username, type:'delete' });
          } else {
            notify(result.message||'unknown error', 'error', 3000);
          }  
        }
      }
      catch(e) {
        notify(e.message||'unknown error', 'error', 3000);
      }
    };
   
    const isSetPasswordPopupVisible = ref(false);
    const showSetUserPass = () => {
      isSetPasswordPopupVisible.value = true;
    }
    const hideSetUserPass = (e) => {
      if (e) isSetPasswordPopupVisible.value = false;
    }

    return {
      DEF_AUTHCODES,
      isMyUserAdmin,
      username,
      webAuthTypes,
      admonAuthTypes,
      iotAuthTypes,
      userPrivileges,
      isDashboardPermUpdatable,

      updateUserAuth,
      teamsDataSource: orgTeamsDataService.dataStore,
      selectedItemKeys,
      userTeamsAccessList,
      updateUserTeams,
      deleteUser,

      showSetUserPass,
      hideSetUserPass,
      isSetPasswordPopupVisible,
    }
  },
}
</script>
<style>
</style>